module.exports = __webpack_public_path__ + "img/pinduoduo_35.03f2d7b7.png";